<template>
  <body>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1 class="title pb-lg-4 mb-5">{{ pageTitle }}</h1>

          <h2 class="header pb-3 pt-lg-3 mb-3 mt-5">
            SELECT A WAY TO VERIFY YOUR ACCOUNT
          </h2>

          <div
            v-if="errorNotification"
          >
            <ErrorMessage
              class="mb-4 mb-lg-5"
              v-bind:errorNotification="errorNotification"
            />
          </div>
          <input
            type="radio"
            id="sms"
            v-bind:value="'sms'"
            class="input-btn mt-2 mr-3"
            v-model="otpMethod"
          />
          <p class="text clickable" v-on:click="otpMethod = 'sms'">
            SMS Text Message (Default)
          </p>
          <p class="text">
            A verification code will be sent to {{ getPhoneNumber() }}
          </p>
          <input
            type="radio"
            id="email"
            v-bind:value="'email'"
            class="input-btn mt-4 mr-3"
            v-model="otpMethod"
          />
          <p class="text mt-3 clickable" v-on:click="otpMethod = 'email'">
            Email
          </p>
          <p class="text pb-3 mb-3">
            A verification code will be sent to your registered email address
          </p>
          <button
            v-on:click="sendOTP"
            type="submit"
            class="btn btn-primary green-btn"
          >
            <b-spinner
              v-if="showLoader"
              label="Spinning"
              class="white-spinner"
            ></b-spinner>
            <div v-if="!showLoader">Send</div>
          </button>
        </div>
      </div>
    </div>
  </body>
</template>

<script>
import ErrorMessage from '@/components/ErrorMessage.vue'
import { sendOTP } from "@/services/2FAClient.js";
import { mapState } from "vuex";

export default {
  name: "SelectVerificationMethod",
  components: {
    ErrorMessage
  },
  data() {
    return {
      pageTitle: "Select Verification Method",
      otpMethod: "sms",
      showLoader: false,
      errorNotification: null
    };
  },
  props: ["verificationMethods"],
  mounted() {
    if (!this.otp?.verificationMethods) {
      this.$router.push("/");
      this.$store.dispatch("reset");
    }
  },
  computed: {
    ...mapState(["otp"]),
  },
  methods: {
    getPhoneNumber() {
      return this.otp?.verificationMethods
        ? this.otp?.verificationMethods.filter((x) => x.type === "sms")[0].value
        : "";
    },
    sendOTP() {
      this.showLoader = true;
      this.errorNotification = null;
      sendOTP(this.otpMethod)
        .then((response) => {
          this.$store.dispatch("saveTokenRef", { tokenRef: response.data.otpRef, verificationMethod: this.otpMethod })
          this.$router.push({ name: 'VerifyOTP'});
        })
        .catch((error) => {
          if (error.response && error.response.status === 400 || error.response.status === 401) {
            this.$store.dispatch("reset");
            this.$router.push("/");
          } else {
            this.errorNotification = "We’re sorry that didn’t work. Please try again."
          }
        })
        .finally(() => (this.showLoader = false));
    },
  },
};
</script>
<style lang="scss" scoped>
.text {
  margin-left: 23px;
}
.input-btn {
  float: left;

  &:hover,
  :active,
  :focus {
    cursor: pointer;
  }
}

.clickable {
  &:hover,
  :active,
  :focus {
    cursor: pointer;
  }
}
</style>